import type {
  BusinessUserListRequestType,
  BusinessUserListResponseType,
} from "@sellar-io/api-v2/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2InfiniteQueryOptions,
  apiV2Request,
  getDefaultInfiniteQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useBusinessUserList = <TData = BusinessUserListResponseType,>(
  params: BusinessUserListRequestType,
  options?: ApiV2InfiniteQueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useInfiniteQuery({
    queryKey: [user?.uid, business?.id, ServerStateKeys.BusinessUser, params],
    queryFn: (queryParams) =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `business-users`,
        params: {
          ...params,
          offset: queryParams.pageParam,
        },
      }).then((response) => apiV2AssertResponse<TData>(response).data),
    ...getDefaultInfiniteQueryOptionsV2({
      context: { scope: "business", user, business: business },
      options: { ...options, limit: params.limit },
    }),
  });
};
